import { GuestSummaryController } from './guest-summary.controller'

const component = {
  templateUrl: '/guest/components/guest-summary/guest-summary.html?$$REVISION$$',
  bindings: {
    type: '@',
    briefingId: '<?',
    approvalId: '<?',
    assetPackId: '<?'
  },
  controllerAs: '$ctrl',
  controller: GuestSummaryController
}

export const guestSummary = component
